import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "error-page" }
const _hoisted_2 = { class: "error-page-content" }
const _hoisted_3 = { class: "logo-wrapper" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "visually-hidden" }
const _hoisted_6 = {
  class: "error-page-title first-part",
  "aria-hidden": "true"
}
const _hoisted_7 = ["alt"]
const _hoisted_8 = { class: "error-page-description" }
const _hoisted_9 = {
  class: "error-page-title second-part",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "error-page-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.brandingInfo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "logo",
              src: _ctx.brandingInfo.logoLarge.url,
              alt: _ctx.brandingInfo.logoLarge.alt
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("h1", _hoisted_5, "404 - " + _toDisplayString(`${_ctx.t('notFound.titleFirstPart')} ${_ctx.t('notFound.titleSecondPart')}`), 1),
      _createElementVNode("h2", _hoisted_6, [
        _cache[0] || (_cache[0] = _createTextVNode(" 404 °N ")),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.t('notFound.titleFirstPart')), 1)
      ]),
      _createElementVNode("img", {
        class: "error-page-image",
        src: "/statics/images/error-page-fg.png",
        alt: _ctx.t('notFound.foregroundImageAlt')
      }, null, 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.t('notFound.titleSecondPart')), 1),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t('notFound.text')), 1),
        _createVNode(_component_IconButton, {
          "icon-name": "earth",
          to: { name: _ctx.mapRouteName },
          transparent: "",
          arrow: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('notFound.linkText')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}